import classnames from 'classnames';
import { FC } from 'react';

import styles from './RestrictedContentPrompt.module.scss';
import { OneClubMastercardFull } from '../../icons';

type RestrictedContentPromptLogosProps = {
  className?: string;
};

export const RestrictedContentPromptLogos: FC<
  RestrictedContentPromptLogosProps
> = () => {
  return (
    <div className={classnames(styles['icon-group'])}>
      <div className={classnames(styles['icon-group__item'])}>
        <OneClubMastercardFull width={224} height={80} />
      </div>
    </div>
  );
};
